import { sendDataLayerEvent } from '../../utils/dataLayerInteractions';
import EventNamesType from '../eventNamesType';

type CheckAvailabilityDataProps = {
  step: string;
  postcode?: string;
  availability?: string;
  itemName: string;
  itemId: string;
};

export function sendCheckAvailabilityEvent({
  step,
  postcode = undefined,
  availability = undefined,
  itemId,
  itemName,
}: CheckAvailabilityDataProps) {
  sendDataLayerEvent(EventNamesType.check_availability, {
    custom_data: {
      step,
      postcode,
      availability,
      item_id: itemId,
      item_name: itemName,
    },
  });
}
